import React from "react"
import Modal from 'react-modal';
import closeIcon from '../images/close.svg';
import Vimeo from '@u-wave/react-vimeo';

Modal.setAppElement('#___gatsby')

export default class VideoModal extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({modalIsOpen: true});
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  render() {


    return (
      <React.Fragment>
      
      <button onClick={this.openModal} className="play-video-button" title={this.props.title} aria-label={this.props.ariaLabel}>
        Play Video
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512" className="icon" role="img" aria-labelledby="play-icon-title">
          <title id="play-icon-title">Play Icon</title>
          <path role="presentation" d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"/>
        </svg>
      </button>

      <Modal
        closeTimeoutMS={400}
        isOpen={this.state.modalIsOpen}
        onRequestClose={this.closeModal}
        contentLabel="Watch Video"
        className="video-modal"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick={true}
      >
        <button onClick={this.closeModal} id="closeButton"><img src={closeIcon} alt="" /> Close</button>
        <Vimeo
          video={this.props.vimeoID}
          responsive
          showTitle={false}
          showByline={false}
          showPortrait={false}
          autoplay
          onEnd={this.closeModal}
        />
      </Modal>
      </React.Fragment>
    );
  }
}